import { useEffect } from 'react';
import { postToParent } from './useIframeMessaging';

function postHeight(): void {
  const height = document.documentElement.scrollHeight;
  postToParent({ type: 'HEIGHT_CHANGED', payload: { height } });
}

export function useAutoResize(): void {
  useEffect(() => {
    postHeight();

    const observer = new ResizeObserver(() => {
      postHeight();
    });

    observer.observe(document.body);

    window.addEventListener('resize', postHeight);

    return () => {
      observer.disconnect();
      window.removeEventListener('resize', postHeight);
    };
  }, []);
}
